export * from "./PopupMessageActionsConfig";
//# sourceMappingURL=index.js.map